var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44 2.4a1.92 1.92 0 100 3.84h1.921V4.32c0-1.059-.859-1.919-1.921-1.92zm0 5.12H4.32a1.92 1.92 0 000 3.84h5.12a1.92 1.92 0 100-3.84z",
    fill: "#36C5F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 9.44a1.92 1.92 0 00-3.84 0v1.92h1.92a1.92 1.92 0 001.92-1.92zm-5.12 0V4.32a1.92 1.92 0 00-3.84 0v5.12a1.92 1.92 0 103.84 0z",
    fill: "#2EB67D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.56 21.6a1.92 1.92 0 100-3.84h-1.92v1.92c-.001 1.059.859 1.918 1.92 1.92zm0-5.12h5.12a1.92 1.92 0 000-3.84h-5.12a1.92 1.92 0 000 3.84z",
    fill: "#ECB22E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4 14.56a1.92 1.92 0 003.841 0v-1.92h-1.92a1.92 1.92 0 00-1.92 1.92zm5.12 0v5.12a1.92 1.92 0 103.84 0v-5.12a1.92 1.92 0 00-3.84 0z",
    fill: "#E01E5A"
  })));
}

export default __webpack_public_path__ + "./fonts/slack.5ed5b956988704f2c66b43aea314070f.svg";
export { SvgSlack as ReactComponent };